module.exports = __webpack_public_path__ + "static/media/exclam.ea18cb06.svg";